import React from 'react'
import ClientList from '../../components/common/ClientList'

const ErbClientList: React.FC<{}> = () => {
  return <ClientList />
}

export default ErbClientList
